import { FmlxButton, FmlxIcon } from 'fmlx-common-ui';
import React from 'react';

const ProteinVariantCard = (props) => {
  const { pFVariant, proteinVariantDoubleClickHandler, handleDeletePfVariant } = props;

  return (
    <div
      id={`proteinvariantcard-wrapper-${pFVariant.treeNodeId}`}
      onDoubleClick={() => proteinVariantDoubleClickHandler(pFVariant.treeNodeId)}
      className="flex flex-row w-[98%] items-center ml-[2%] mb-[2.5%] border border-solid border-[#B4B4B4] rounded-[4px] hover:bg-blue-300 hover:cursor-pointer"
    >
      <div id={`proteinvariantcard-content-${pFVariant.treeNodeId}`} className="w-[100%] flex flex-row mt-[0.4rem]">
        <div id={`proteinvariantcard-details-${pFVariant.treeNodeId}`} className="w-[90%] pl-[2%] h-[100%] flex flex-col">
          <div id={`proteinvariantcard-title-${pFVariant.treeNodeId}`} className="text-[#313131] font-bold text-[12px] h-[15px]">
            {pFVariant.treeNode.name}
          </div>
          {pFVariant.proteinFormulationIngredient.map((pfIng) => (
            <div
              key={`proteinvariantcard-ingredient-${pFVariant.treeNodeId}`}
              id={`proteinvariantcard-ingredient-${pFVariant.treeNodeId}`}
              className="h-[18px] text-[12px] text-[#5D5D5D]"
            >
              {pfIng.proteinFormulationIngredientType.name} : {pfIng.name},{' '}
              {pfIng.concentrationmgmL || 0} mg/mL, {pfIng.concentrationmM || 0} mM
            </div>
          ))}
        </div>
        <div id={`proteinvariantcard-delete-${pFVariant.treeNodeId}`} className="w-[10%] flex h-[100%] justify-center">
          <FmlxButton
            id={`proteinvariantcard-delete-button-${pFVariant.treeNodeId}`}
            onlyIcon
            icon={<FmlxIcon name="Trash" />}
            type={FmlxButton.Type.DANGER}
            onClick={() =>
              handleDeletePfVariant(
                pFVariant.treeNodeId,
                pFVariant.treeNode.name,
                pFVariant.treeNode.type,
              )
            }
            tooltipDescription="Delete"
            withTooltip
            tooltipPlacement={FmlxButton.TooltipPlacement.BOTTOM}
          />
        </div>
      </div>
    </div>
  );
};

export default ProteinVariantCard;
